(function() {
    'use strict';
    angular
        .module('cbl.finanza.mf.directives')
        .service('FinDossierCompositionSrvc', [
            '$http',
            'FIN_CONSTANTS',
            function($http, CONSTANTS) {
                this.inputCompositionForm = {
                    startDate: null,
                    isRaggruppaDerivati: false
                };

                this.datasource = null;
                this.controvaloreComposizione = null;
                this.gridComposizioneProdottoOptions = null;
                this.gridApi = null;

                // Gestione delle viste
                this.views = {
                    defaultView: {
                        title: 'Composizione',
                        url: CONSTANTS.BASE_ROOT +
                            'widgets/finDossierComposition/states/finDossierComposition.states.table.html',
                        visible: true,
                        searchEnabled: true,
                        type: 'TABLE'
                    },
                    listView: [{
                            title: 'Composizione',
                            url: CONSTANTS.BASE_ROOT +
                                'widgets/finDossierComposition/states/finDossierComposition.states.table.html',
                            visible: true,
                            searchEnabled: true,
                            type: 'TABLE'
                        },
                        {
                            title: 'Grafico',
                            url: CONSTANTS.BASE_ROOT +
                                'widgets/finDossierComposition/states/finDossierComposition.states.graph.html',
                            visible: true,
                            searchEnabled: true,
                            type: 'GRAPH'
                        },
                        {
                            title: 'Dettaglio titolo',
                            url: CONSTANTS.BASE_ROOT +
                                'widgets/finDossierComposition/states/finDossierComposition.states.details.html',
                            visible: false,
                            searchEnabled: false,
                            type: 'DETAIL'
                        }
                    ]
                };

                // Gestione dei raggruppamenti
                this.groups = {
                    defaultGroup: {
                        title: 'Nessuno (per Isin)',
                        field: 'CodiceIsin',
                        grouping: false,
                        row: 1,
                        graph: false
                    },
                    listGroup: [{
                            title: 'Tipologia',
                            field: 'Tipologia',
                            grouping: 'Tipologia',
                            row: 1,
                            graph: true
                        },
                        {
                            title: 'Divisa',
                            field: 'DivisaQuotazione',
                            grouping: 'Divisa',
                            row: 1,
                            graph: true
                        },
                        {
                            title: 'Nessuno (per Isin)',
                            field: 'CodiceIsin',
                            grouping: false,
                            row: 1,
                            graph: false
                        }
                    ]
                };

                this.currentItem = null;
                // Determina se sto facendo una ricerca (e quindi mostro il loader) o se non ho
                // trovato risultati (e mostro il messaggio di nessun elemento trovato)
                this.searchInProgress = false;

                this.callComposition = function(url, body, success, error) {
                    $http.post(url, body).then(success, error);
                };

                this.remapComposition = function(composizione) {
                    if (!composizione) {
                        return null;
                    }
                    var result = [];
                    composizione.forEach(function(comp) {
                        result.push({
                            CambioCarico: comp.cambioCarico,
                            CambioMercato: comp.cambioMercato,
                            ClasseRischioComplessita: comp.classeRischioComplessita,
                            ClasseRischioEmittente: comp.classeRischioEmittente,
                            ClasseRischioMercato: comp.classeRischioMercato,
                            CodiceIsin: comp.codiceIsin,
                            CodiceTitolo: comp.codiceTitolo,
                            CodiceRischioComplessita: comp.codiceRischioComplessita,
                            CodiceRischioEmittente: comp.codiceRischioEmittente,
                            CodiceRischioMercato: comp.codiceRischioMercato,
                            Controvalore: comp.controvalore,
                            DataPrezzoMercato: comp.dataPrezzoMercato,
                            Descrizione: comp.descrizione,
                            DivisaQuotazione: comp.divisaQuotazione,
                            ImportoPlusMinValenza: comp.importoPlusMinValenza,
                            Intestatario: comp.intestatario,
                            PercPlusMinValenza: comp.percPlusMinValenza,
                            PrezzoMedioCarico: comp.prezzoMedioCarico,
                            PrezzoMercato: comp.prezzoMercato,
                            Quantita: comp.quantita,
                            QuantitaDisponibile: comp.quantitaDisponibile,
                            RateoMercato: comp.rateoMercato,
                            Tipologia: comp.tipologia,
                            quantita: comp.quantita,
                            quantitaDisponibile: comp.quantitaDisponibile
                        });
                    });
                    return result;
                };
            }
        ]);
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierComposition/finDossierCompositionSrvc.js
 ** module id = 33
 ** module chunks = 1 2
 **/